export default function unflatten(obj) {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
        const parts = key.split(".");
        let current = result;
        parts.forEach((part, i) => {
            if (i === parts.length - 1) {
                current[part] = value;
            } else {
                if (!current[part]) current[part] = {};
                current = current[part];
            }
        });
    }
    return result;
}
